import React from "preact";
import { Plugin } from '@uppy/core';
import dragDrop  from 'drag-drop'


export default class extends Plugin {
  constructor (uppy, options) {
    super(uppy, options)
    this.type = 'acquirer'
    this.id = options.id
    this.options = options

    this.isDragDropSupported = this.checkDragDropSupport()
  }

  checkDragDropSupport = () => {
    const div = document.createElement('div')

    if (!('draggable' in div) || !('ondragstart' in div && 'ondrop' in div)) {
      return false
    }

    if (!('FormData' in window)) {
      return false
    }

    if (!('FileReader' in window)) {
      return false
    }

    return true
  }

  handleDrop = files => {
    files.forEach((file) => {
      try {
        this.uppy.addFile({
          source: this.id,
          name: file.name,
          type: file.type,
          data: file
        })
      } catch (err) {
        // No Action.
      }
    })
  }

  addContainerStyles = () => {
      this.container.style.border = '4px dashed #000'
      this.container.style.zIndex = '3'
      this.container.style.color = '#000'
  }

  removeContainerStyles = () => {
    this.container.style.border = '0'
    this.container.style.zIndex = '1'
    this.container.style.color = 'transparent'
  }

  render () {
    if (!this.isDragDropSupported) return null;
    const DragDropContainerClass = {
      position: 'absolute',
      top: 0,
      right: 260,
      bottom: 30,
      left: 0,
      zIndex: 1,
      background: 'rgb(250,250,255)',
      color: 'transparent',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      placeContent: 'center center'
    }
    const DropMessage = {
      textAlign: 'center',
      color: '#d3d3d3'
    }
    return (
      <div style={DragDropContainerClass}
           onDragOver={this.addContainerStyles}
           onDrop={this.removeContainerStyles}
           onDragLeave={this.removeContainerStyles}
           ref={container => {
            this.container = container
           }}>
        <h1 style={DropMessage}>Drop your video files here.</h1>
      </div>
    )
  }

  install () {
    const target = this.options.target
    if (target) {
      this.el = this.mount(target, this)
    }
    this.removeDragDropListener = dragDrop(this.el, (files) => {
      this.handleDrop(files)
    })
  }

  uninstall () {
    this.unmount()
    this.removeDragDropListener()
  }
}



// WEBPACK FOOTER //
// ./src/Components/VideoUpload/VideoUploadPlugin.js